import { createModel } from "@rematch/core";
import { CustomerGroupFilterState, LatLongState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: LatLongState = {
  data: [],
  loading: false,
  pending: null,
};

export const latLong = createModel<RootModel>()({
  state: initialState as LatLongState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(state, payload: LatLongState, requestId: string) {
      return multiRequest.updateSuccess(payload, state, requestId);
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchLatLong(
      customerGroupFilter: CustomerGroupFilterState,
      rootState
    ) {
      const requestId = multiRequest.getRequestId();
      dispatch.latLong.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.latLong.fetchFail(requestId)
      );
      if (!token) return;

      try {
        const latLongResult = await api.fetchLatLong(
          token,
          customerGroupFilter
        );
        dispatch.latLong.fetchSuccess(latLongResult, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.latLong.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/latLong.ts